import { Modal } from "./Modal";

interface SuccessModalProps {
  emoji?: string;
  title: string;
  message: string;
  actionLabel: string;
  onAction: () => void;
}

/** Modal de celebración glassmorphism — usado p.ej. al completar el registro */
export function SuccessModal({ emoji = "🎉", title, message, actionLabel, onAction }: SuccessModalProps) {
  return (
    <Modal onClose={onAction}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>{emoji}</div>
        <h2 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 24, margin: "0 0 10px" }}>
          {title}
        </h2>
        <p style={{ fontSize: 14.5, color: "var(--muted)", lineHeight: 1.6, margin: "0 0 26px" }}>
          {message}
        </p>
        <button onClick={onAction} className="btn btn-primary btn--full">
          {actionLabel}
        </button>
      </div>
    </Modal>
  );
}
